import { createApp } from "vue"
import { Settings } from "luxon"
import { createPinia } from "pinia"
import { createHead } from "@vueuse/head"
import { VueCookieNext } from "vue-cookie-next"
import App from "./App.vue"
import router from "./router"

import { watchOverflow } from "./directives/watchOverflow"

import "vfonts/Inter.css"
import "vfonts/FiraCode.css"

Settings.defaultLocale = "en"

const app = createApp(App)

app
  .use(createPinia())
  .use(createHead())
  .use(router)
  .use(VueCookieNext)

app.directive("watch-overflow", watchOverflow)
app.mount("#app")
